import React from 'react';
import PropTypes from 'prop-types';

// Inherits colour from its container, so callers style it with `color`.
const CheckIcon = ({ size }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 16 16"
    aria-hidden="true"
    focusable="false"
  >
    <path
      d="M3 8.5 6.2 11.7 13 5"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

CheckIcon.propTypes = {
  size: PropTypes.number,
};

CheckIcon.defaultProps = {
  size: 14,
};

export default CheckIcon;
